var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.25C3.75 1.00736 4.75736 0 6 0H12.75C13.9927 0 15 1.00736 15 2.25V9C15 10.2427 13.9927 11.25 12.75 11.25H11.25V12.75C11.25 13.9927 10.2427 15 9 15H2.25C1.00736 15 0 13.9927 0 12.75V6C0 4.75736 1.00736 3.75 2.25 3.75H3.75V2.25ZM5.25 3.75H9C10.2427 3.75 11.25 4.75736 11.25 6V9.75H12.75C13.1642 9.75 13.5 9.41422 13.5 9V2.25C13.5 1.83579 13.1642 1.5 12.75 1.5H6C5.58579 1.5 5.25 1.83579 5.25 2.25V3.75ZM2.25 5.25C1.83579 5.25 1.5 5.58579 1.5 6V12.75C1.5 13.1642 1.83579 13.5 2.25 13.5H9C9.41422 13.5 9.75 13.1642 9.75 12.75V6C9.75 5.58579 9.41422 5.25 9 5.25H2.25Z",
    fill: "#0E1318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.0498C5.6525 7.0498 5.79842 7.11092 5.90625 7.21875C6.01408 7.32658 6.0752 7.4725 6.0752 7.625V8.9248H7.375C7.5275 8.9248 7.67342 8.98592 7.78125 9.09375C7.88908 9.20158 7.9502 9.3475 7.9502 9.5C7.9502 9.6525 7.88908 9.79842 7.78125 9.90625C7.67342 10.0141 7.5275 10.0752 7.375 10.0752H6.0752V11.375C6.0752 11.5275 6.01408 11.6734 5.90625 11.7812C5.79842 11.8891 5.6525 11.9502 5.5 11.9502C5.3475 11.9502 5.20158 11.8891 5.09375 11.7812C4.98592 11.6734 4.9248 11.5275 4.9248 11.375V10.0752H3.625C3.4725 10.0752 3.32658 10.0141 3.21875 9.90625C3.11092 9.79842 3.0498 9.6525 3.0498 9.5C3.0498 9.3475 3.11092 9.20158 3.21875 9.09375C3.2997 9.0128 3.40205 8.95858 3.5127 8.93652L3.625 8.9248H4.9248V7.625C4.9248 7.4725 4.98592 7.32658 5.09375 7.21875C5.20158 7.11092 5.3475 7.0498 5.5 7.0498Z",
    fill: "#0E1318",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.0e69369309f3e81a65f510374ad95022.svg";
export { ForwardRef as ReactComponent };